module.exports = __webpack_public_path__ + "img/blue_168.b43ed0bb.png";